import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CoreCommonModule } from 'src/@core/common.module';
import { CoreTouchspinComponent } from './core-touchspin.component';


@NgModule({
  declarations: [CoreTouchspinComponent],
  imports: [CommonModule, FormsModule, CoreCommonModule],
  exports: [CoreTouchspinComponent]
})
export class CoreTouchspinModule {}
